import LabelWithPopover from "@/components/form/labels/LabelWithPopover";
import AntIcon from "@/components/icons/AntIcon";
import { Alert, Col, Row, Space, Switch } from "antd";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { useIsCurrentAgentTypePlus } from "../../../../auth/hooks";

const APPROVAL_NUMBERS = [1, 2, 3, 4, 5, 6];

interface Props {
  approvals: boolean[];
  allApprovals: boolean;
  handleAllApprovals: VoidFunction;
  handleApprovalChange: (checked: boolean, index: number) => void;
}

export const ClientApprovalsCalcSummaryView = ({
  approvals,
  allApprovals,
  handleAllApprovals,
  handleApprovalChange,
}: Props) => {
  const { t } = useTranslation();

  const isTopAgentPlus = useIsCurrentAgentTypePlus();

  return (
    <>
      <div className="margin-bottom-medium">
        <b>{t("calc.helpers.clientApprovals.subtitle")}</b>
      </div>

      {APPROVAL_NUMBERS.map((approvalNumber) => (
        <React.Fragment key={approvalNumber}>
          <Row className="margin-bottom-medium">
            <Col span={21}>
              <b>{approvalNumber}.</b>
              {isTopAgentPlus ? (
                <LabelWithPopover
                  className="margin-left-tiny"
                  popoverContent={
                    <div style={{ maxWidth: 500, fontSize: 12 }}>
                      <Trans
                        i18nKey={`calc.helpers.clientApprovals.approval${approvalNumber}Hint`}
                        components={{ a: <a target="_blank" rel="noreferrer" /> }}
                      />
                    </div>
                  }
                  label={t("calc.helpers.clientApprovals.approval" + approvalNumber)}
                />
              ) : (
                <span className="margin-left-tiny">{t("calc.helpers.clientApprovals.approval" + approvalNumber)}</span>
              )}
            </Col>
            <Col span={3}>
              <Space>
                <Switch
                  checked={approvals[approvalNumber - 1]}
                  checkedChildren={<AntIcon type="check" />}
                  unCheckedChildren={<AntIcon type="close" />}
                  onChange={(checked) => handleApprovalChange(checked, approvalNumber - 1)}
                />
                <span>{(approvals[approvalNumber - 1] ? t("common.yes") : t("common.no")).toLowerCase()}</span>
              </Space>
            </Col>
          </Row>
        </React.Fragment>
      ))}

      <Row className="margin-top-large">
        <Col span={21}>
          <b>{t("calc.helpers.clientApprovals.allApprovals")}</b>
        </Col>
        <Col span={3}>
          <Space>
            <Switch
              checked={allApprovals}
              checkedChildren={<AntIcon type="check" />}
              unCheckedChildren={<AntIcon type="close" />}
              onChange={handleAllApprovals}
            />
            <span>{(allApprovals ? t("common.yes") : t("common.no")).toLowerCase()}</span>
          </Space>
        </Col>
      </Row>

      {approvals.some((approval) => !approval) && (
        <Alert
          className="margin-top-medium"
          type="warning"
          showIcon
          title={t("calc.helpers.clientApprovals.validationMessage")}
        />
      )}
    </>
  );
};
